/**
* 触发器
*/
const trigger = {
  
addTrigger: "/api/addTrigger",//添加
modifyTrigger: "/api/modifyTrigger",//修改
enableTrigger: "/api/enableTrigger",//启用
disableTrigger: "/api/disableTrigger",//停用
deleteTrigger: "/api/deleteTrigger",//删除
getTriggers: "/api/getTriggers",//查询
getTriggerVariablesValue: "/api/getTriggerVariablesValue",//获取触发器变量值
}

export default trigger